import { FC } from 'react';
import { BrowserRouter } from 'react-router-dom';

import AnonimusRoutes from './AnonimusRoutes';

const Router: FC = () => {
  return (
    <BrowserRouter>
      <AnonimusRoutes />
    </BrowserRouter>
  );
};

export default Router;
